module.exports = __webpack_public_path__ + "static/4.2_Musicrecommendations_NO-3cbb96de3c7a7431dd85a71a1503897d.svg";